import { render } from "./support-bundle-namespaces.vue?vue&type=template&id=54f410cc"
import script from "./support-bundle-namespaces.vue?vue&type=script&lang=js"
export * from "./support-bundle-namespaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__